<template>
    <DCard
        padding
    >
        <Form
            :countries="countries"
            :company-information="companyInformation"
            :vat-id-check-types="vatIdCheckTypes"
            :vat-id-check-type-default="vatIdCheckTypeDefault"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/CompanyInformation/Form'

export default {
    name: 'CompanyInformationCreate',
    components: {
        Form
    },
    props: {
        countries: {
            type: Array,
            default () {
                return []
            }
        },
        companyInformation: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        vatIdCheckTypes: {
            type: Array,
            default: () => { return [] }
        },
        leadDayForInvoiceVatIdCheckDefault: {
            type: Number,
            default: () => { return 14 }
        },
        vatIdCheckTypeDefault: {
            type: String,
            default: () => { return 'do_not_check' }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.company-information.store'))
        }
    }
}
</script>
